import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, Slider, Text } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useState } from "react";
export const SliderInput = ({ label, min, max, step, value, marks, debounce = 200, sliderLabel, onChange, }) => {
    const [temp, setTemp] = useState(value);
    const [debounced, cancel] = useDebouncedValue(temp, debounce);
    // biome-ignore lint/correctness/useExhaustiveDependencies: cancel is not stable reference @see https://github.com/mantinedev/mantine/pull/8181
    useEffect(() => {
        cancel();
        setTemp(value);
    }, [value]);
    useEffect(() => {
        onChange(debounced);
    }, [debounced, onChange]);
    return (_jsxs(Group, { gap: "sm", h: "30px", children: [label && (_jsx(Text, { size: "xs", fw: 500, w: "18ch", children: label })), _jsx(Slider, { flex: 1, min: min, max: max, step: step, size: "xs", marks: marks, value: temp, label: sliderLabel, onChange: setTemp })] }));
};
